module.exports = __webpack_public_path__ + "img/danxiangpaiqifa-wai.27eb7b31.jpg";